import React from 'react';

import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { useTranslation } from 'react-i18next';

// Components
import TermsAndConditionsBody from '../components/Layout/TermsAndConditionsBody';
import Banner from '../components/UI/Banner';
import BrandingDAS from '../components/Layout/BrandingDAS';

const Root = styled('div')(({ theme }) => ({
  '.banner__header': {
    fontSize: `6rem !important`,
    lineHeight: '1.275',
    letterSpacing: '0.47',
    [theme.breakpoints.down('sm')]: {
      fontSize: `5rem !important`,
    },
  },
}));

export default function TermsAndConditions() {
  const { t, i18n } = useTranslation(['termsAndConditions', 'common']);

  React.useEffect(() => {
    setTimeout(() => {
      document.title = `${t('common:daaas')} - ${t(
        'termsAndConditions:termsAndConditions'
      )}`;
      document
        .querySelector("meta[name='description']")
        .setAttribute('content', t('termsAndConditions:description'));
      document
        .querySelector("meta[name='keywords']")
        .setAttribute('content', t('termsAndConditions:keywords'));
      document
        .querySelector("link[rel='canonical']")
        .setAttribute('href', t('termsAndConditions:canonical'));
      document
        .querySelector("meta[name='dcterms.title']")
        .setAttribute('content', t('termsAndConditions:dctermsTitle'));
      document
        .querySelector("meta[name='dcterms.description']")
        .setAttribute('content', t('termsAndConditions:dctermsDescription'));
      document
        .querySelector("meta[name='dcterms.creator']")
        .setAttribute('content', t('common:dctermsCreator'));
      document
        .querySelector("meta[name='dcterms.language']")
        .setAttribute('content', t('common:dctermsLanguage'));
      document
        .querySelector("meta[name='dcterms.subject']")
        .setAttribute('content', t('common:dctermsSubject'));
    }, '100');
  }, [i18n.language]);

  return (
    <Root>
      <Banner>
        <Typography
          className="banner__header"
          variant="h1"
          color="textPrimary"
          sx={{ py: 2 }}
        >
          {t('termsAndConditions:termsAndConditions')}
        </Typography>
      </Banner>
      <TermsAndConditionsBody />
      <BrandingDAS />
    </Root>
  );
}
